import React from 'react'

const TodoContext = React.createContext([]);

export default TodoContext;
